import { ComponentProps } from 'react';
import clsx from 'clsx';

import { OpButton } from 'new-components/DLS/OpButton/OpButton';
import { OpSkeleton } from 'new-components/DLS/OpSkeleton/OpSkeleton';

import { useOpFormContext } from '../../OpFormContext';
import { OpForm } from '../../OpForm';

interface OpFormButtonProps
  extends Pick<ComponentProps<typeof OpForm.Item>, 'label'>,
    Omit<ComponentProps<typeof OpButton>, 'name'> {
  formItemClassName?: string;
  isLoading?: boolean;
}

export const OpFormButton = ({
  // Form Item props
  formItemClassName,
  label,

  // For skeleton loading state
  isLoading,

  // Wrapped element props
  className,

  disabled,
  ...elementProps
}: OpFormButtonProps) => {
  /** The Form is wrapped in a provider that passes the loading context
   *  to the component */
  const { isDataLoading, isReadOnly } = useOpFormContext();

  return (
    <OpForm.Item
      className={clsx('op-form-button', formItemClassName)}
      label={label}
    >
      {isDataLoading || isLoading ? (
        /** A placeholder in the shape of the component
         * so we can immediately render the structure of the form while
         * data is loading */
        <OpSkeleton.Button active block={elementProps.block} />
      ) : (
        /** The actual component that is rendered when we have the data */
        <OpButton
          disabled={isReadOnly || disabled}
          className={className}
          {...elementProps}
        />
      )}
    </OpForm.Item>
  );
};
